import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-538">
      <Navbar data-id="element-539" />
      <main data-id="element-540">
        <HeroSection data-id="element-541" />
        <ProblemSection data-id="element-542" />
        <HowItWorks data-id="element-543" />
        <ValueProposition data-id="element-544" />
        <UseCases data-id="element-545" />
        <ProductDeepDive data-id="element-546" />
        <Pricing data-id="element-547" />
        <TrustSecurity data-id="element-548" />
        <FinalCTA data-id="element-549" />
      </main>
      <Footer data-id="element-550" />
    </div>;
}